import './style/custom-solio.css';
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Register from './components/Register';
import Navbar from './components/Navbar';
import JobList from './components/JobList';
import JobForm from './components/JobForm';
import CandidatesList from './components/CandidatesList';
import DashboardStats from './components/DashboardStats';
import PublicOffersTest from './components/PublicOffersTest';
import CandidateForm from './components/CandidateForm';
import PipelineCandidatesBoard from './components/PipelineCandidatesBoard';
import FilialesDashboard from './components/FilialesDashboard';
import FilialeView from './components/FilialeView';
import JobEditPage from './components/JobEditPage';
import DebugJobsJSON from './components/DebugJobsJSON';

function App() {
  const [admin, setAdmin] = useState(null);
  const [isRegister, setIsRegister] = useState(false);

  const isGlobalAdmin = ['admin', 'ceo'].includes(admin?.role);

  useEffect(() => {
    const saved = sessionStorage.getItem('admin');
    if (saved) setAdmin(JSON.parse(saved));
  }, []);

  const handleLogin = (user) => {
    sessionStorage.setItem('admin', JSON.stringify(user));
    setAdmin(user);
  };

  const handleLogout = () => {
    sessionStorage.removeItem('admin');
    setAdmin(null);
  };

  return (
    <Router>
      <div className="App">
        {admin && (
          <Navbar isAdmin={isGlobalAdmin} admin={admin} onLogout={handleLogout} />
        )}

        <div className="container" style={{ marginTop: '80px' }}>
          <Routes>
            {/* ✅ Routes publiques */}
            <Route path="/test-offres" element={<PublicOffersTest />} />
            <Route path="/postuler/:jobId" element={<CandidateForm />} />
            <Route path="/debug-json" element={<DebugJobsJSON />} />

            {!admin ? (
              <>
                {/* 🔐 Authentification */}
                <Route
                  path="/"
                  element={
                    <div className="container mt-5">
                      {isRegister ? (
                        <>
                          <Register onSwitchToLogin={() => setIsRegister(false)} />
                          <div className="text-center mt-4">
                            <p>Déjà inscrit ?</p>
                            <button className="btn btn-primary" onClick={() => setIsRegister(false)}>
                              Se connecter ici
                            </button>
                          </div>
                        </>
                      ) : (
                        <>
                          <Login onLogin={handleLogin} />
                          <div className="text-center mt-4">
                            <p>Pas encore de compte ?</p>
                            <button className="btn btn-primary" onClick={() => setIsRegister(true)}>
                              S'inscrire ici
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                  }
                />
                <Route path="*" element={<Navigate to="/" />} />
              </>
            ) : (
              <>
                {/* 👑 Vue globale pour admin/ceo */}
                <Route
  path="/dashboard"
  element={
    <>
      {/* ✅ On filtre par filiale uniquement pour les managers */}
      <DashboardStats
        role={admin.role}
        filiale={admin.role === 'manager' ? admin.filiale : null}
      />
      <JobList
        role={admin.role}
        filiale={admin.role === 'manager' ? admin.filiale : null}
      />
      <CandidatesList
        role={admin.role}
        filiale={admin.role === 'manager' ? admin.filiale : null}
      />
    </>
  }
/>


                {/* 👤 Vue d'une filiale spécifique */}
                <Route
                  path="/filiale/:filialeName"
                  element={<FilialeView role={admin.role} />}
                />

                {/* ➕ Création d'une offre */}
                <Route path="/create-job" element={<JobForm filiale={admin.filiale} />} />

                {/* ✏️ Édition d'une offre */}
                <Route path="/edit-job/:jobId" element={<JobEditPage />} />

                {/* 🔁 Redirection par défaut */}
                <Route
                  path="*"
                  element={
                      <Navigate to="/dashboard" />
                  }
                />
              </>
            )}
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
